import React  from 'react'
import PropTypes from 'prop-types'

const PageHeader = ({ name }) => (
  <div className='slds-page-header'>
    <div className="slds-page-header__title slds-truncate slds-align-middle" title={name}>
      {name}
    </div>
  </div>
)

PageHeader.propTypes = {
  name: PropTypes.string.isRequired
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/page-header/index.js